module.exports = __webpack_public_path__ + "static/media/classical-physics.f9374da2.svg";